import { action, observable, runInAction } from "mobx";
import { RootStore } from ".";
import { fetchWrapper } from "../common/Fetch";
import { PagedList } from "./CommonStore";
import { SuccessableResult } from "../common/BaseClasses";
import { formatDateJson } from "../common/Formatting";


export interface VinQueryItem {
    id: number;
    description: string;
    type: string;
    comment: string;
    count: number;
}

export interface VinQuery {
    id: number;
    sourceSite: string;
    messagesCount: number;
    customerId: string;
    customerName: string;
    customerPhone: string;
    carName: string;
    engineDisplacement: string;
    engineCapacity: string;
    engineType: string;
    year: number;
    vin: string;
    dateAdded: Date;
    comment: string;
    carComment: string;
    isOpened: boolean;
}

export interface VinQueryMessage {
    date: Date;
    message: string;
    userName: string;
    isManager: boolean;
}

export interface VinQueryDetails extends VinQuery {
    items: VinQueryItem[];
    messages: VinQueryMessage[];
}

export class VinQueriesStore {



    _rootStore: RootStore;

    @observable unreadedCount = 0;

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadVinQueries(
        customerId: string,
        page = 1,
        source: string | undefined,
        dateFrom: Date | undefined,
        dateTo: Date | undefined,
        searchString: string | undefined,
        callback: (vinQueries: VinQuery[], currentPage: number, totalCount: number) => void) {

        customerId = customerId == "-1" ? "" : customerId;
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);
        source = source || "";

        fetchWrapper(`api/vin/list/${page}?customerId=${customerId}&source=${source}&dateFrom=${dateFromStr}&dateTo=${dateToStr}&searchString=${searchString || ''}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<VinQuery>>)
            .then(result => {
                runInAction("fetch complete loadOrders", () => {
                    callback(result.items, page, result.totalItemCount);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
    @action
    loadVinQueryDetails(
        id: number,
        callback: (vinQuery: VinQueryDetails) => void) {

        fetchWrapper(`api/vin/details/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<VinQueryDetails>)
            .then(result => {
                runInAction("fetch complete loadOrders", () => {
                    callback(result);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadUnreadedVinQueryCount() {
        if (this._rootStore.authStore.isAuthenticated && (this._rootStore.authStore.isCallCentre || this._rootStore.authStore.isFranchise))
            fetchWrapper(`api/vin/unreadedcount`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }, this._rootStore.commonStore, false)
                .then(res => res.json() as Promise<number>)
                .then(result => {
                    runInAction("fetch complete loadNewRejectionsCount", () => {
                        this.unreadedCount = result;
                    });
                })
                .catch(res => {
                    console.log(res);
                });
    }

    @action
    sendMessage(message: string, id: number, formUniqueKey: number, successCallback: () => void) {

        const data = new FormData();
        data.append('message', message);
        data.append('formUniqueKey', formUniqueKey.toString());

        fetchWrapper(`api/vin/sendmessage/${id}`, {
            method: 'POST',
            body: data,
            // headers: {
            //     'Content-Type': 'application/json'
            // }
        }, this._rootStore.commonStore, false)
            .then(res => res.json() as Promise<SuccessableResult<object>>)
            .then(result => {
                runInAction("fetch complete sendMessage", () => {
                    if (result.isSuccess) {
                        this._rootStore.commonStore.notifyInfo("Сообщение отправлено!");
                        successCallback();
                    }
                    else {
                        this._rootStore.commonStore.notifyError("Ошибка отправки сообщения. \r\n" + result.errorMessage);
                    }
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
}